import React from 'react';
import styled from 'styled-components';

import { ShowMapButton } from '../ShowMapButton';
import { breakpoints } from '../../constants';
import { useStateContext } from '../../context';

interface IProps {
    className?: string;
}

const BaseToggleViewBar: React.FC<IProps> = ({ className }) => {
    const { setShowMobileMap } = useStateContext();

    const handleMapButtonClick = () => {
        setShowMobileMap(true);
    };

    return (
        <div className={className}>
            <ShowMapButton onClick={handleMapButtonClick} />
        </div>
    );
};

export const ToggleViewBar = styled(BaseToggleViewBar)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    ${ShowMapButton} {
        margin-left: auto;
    }

    @media (${breakpoints.mediumMin}) {
        display: none;
    }
`;
